import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { format } from '@fs/zion-locale/date-fns'
import { boolAttr } from '@fs/zion-frontend-friends'
import { Separator } from '@fs/zion-ui'
import useIsMobile from '../../hooks/useIsMobile'
import countdownBG from '../../images/countdown.jpg'
import CountDown from './main-banner/CountDown'
import { RTCInitialState } from '../../state/RTCReducer'

const dateTimeCss = css`
  color: #fc4e6d;
  font-size: 64px;
  line-height: 70px;
  font-weight: 700;
  text-transform: uppercase;
  &[is-mobile] {
    font-size: 38px;
    line-height: 40px;
  }
`
const watchLiveCss = css`
  font-weight: 700;
  font-size: 42px;
  &[is-mobile] {
    font-size: 20px;
    line-height: 40px;
  }
`

const sectionContainerCss = css`
  overflow: hidden;
  position: relative;
  z-index: 1;
  padding: 10px 25%;
  max-width: 1280px;
  height: 720px;
  background: url(${countdownBG});
  background-repeat: no-repeat;
  background-position-x: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  &[is-mobile] {
    height: 360px;
    background-width: 100%;
    background-size: cover;
  }
`

const CountdownPlaceholder = ({ startTime, isSmall }) => {
  const isMobile = useIsMobile()
  const isSmallSize = isSmall ?? isMobile
  const [t] = useTranslation()
  const nowMS = Date.now() + RTCInitialState.timeOffset
  const showCountdown = startTime - nowMS < 3600000 // Show the countdown if we are within 1 hour of start time

  return (
    <div css={sectionContainerCss} is-mobile={boolAttr(isSmallSize)}>
      <h2 css={watchLiveCss} is-mobile={boolAttr(isSmallSize)}>
        {t('session.watch-live.label', 'WATCH LIVE')}
      </h2>
      <h3 css={dateTimeCss} is-mobile={boolAttr(isSmallSize)}>
        {format(new Date(startTime), 'PPPPp (z)')}
      </h3>
      <Separator size={isMobile ? 'xs' : 'xl'} />
      {showCountdown && (
        <CountDown
          startTime={startTime}
          timesToShow={{
            days: false,
            hours: false,
            minutes: true,
            seconds: true,
          }}
        />
      )}
    </div>
  )
}

export default CountdownPlaceholder
